<template>
  <div id="daily_kline">
    <div id="kline" ref="kline"></div>
  </div>
</template>
<script>
import HQChart from "hqchart";
import bus from "@/assets/js/bus";

var stock_model = {
  code: "600570",
  name: "恒生电子",
  market: "上海A股",
  errorRange: 100,
  modelType: "Butterfly",
  marketType: "Bearish",
  x: "20210429",
  a: "20210514",
  b: "20210520",
  c: "20210521",
  d: "20210525",
  xValue: "94.68",
  aValue: "83.42",
  bValue: "93",
  cValue: "88.5",
  dValue: "98.79"
};

var axios;

function DefaultData() {}
DefaultData.GetKLineOption = function() {
  function NetworkFilter(data, callback) {
    console.log("[NetworkFilter] data ", data);

    data.PreventDefault = true; //设置hqchart不请求数据
    var param = { code: stock_model.code, name: stock_model.name, count: 500 };

    axios
      .post("/api/stock_day", param)
      .then(result => {
        //var hqchartData;//把第3方数据data转成 hqchart数据
        console.log(result);
        callback(result.data); //把数据传回hqchart
      })
      .catch(err => {
        console.log("获取模型数据，解析失败！");
      });

    if (data.Name == "APIScriptIndex::ExecuteScript") {
      var request = data.Request;
      //request;
      if (request.Data.indexname == "多线段指标") {
        var hqchart = data.HQChart;
        var kData = hqchart.ChartPaint[0].Data;

        var closeLine = { name: "收盘价线", type: 0, data: kData.GetClose() };

        var gartley_line = {
          name: "MULTI_LINE",
          type: 1,
          Draw: {
            DrawType: "MULTI_LINE",
            DrawData: []
            //LineDash: [3, 3]
          } //绘制线段数组
        };

        var xbd_line = {
          name: "MULTI_LINE",
          type: 1,
          Draw: {
            DrawType: "MULTI_LINE",
            DrawData: [],
            LineDash: [3, 3]
          } //绘制线段数组
        };

        var model_text_show_value;
        if (stock_model.marketType == "Bullish") {
          model_text_show_value = Math.max(
            stock_model.aValue,
            stock_model.cValue
          );
        } else {
          model_text_show_value = stock_model.bValue * 1.1; //模型类别显示稍高于B点的值
        }

        var pointColor = "rgb(47,79,79)";

        var text = {
          name: "MULTI_TEXT",
          type: 1,
          Draw: {
            DrawType: "MULTI_TEXT",
            DrawData: [
              {
                Date: stock_model.x,
                Time: 0,
                Value: stock_model.xValue,
                Text: "X",
                Color: pointColor
              },
              {
                Date: stock_model.a,
                Time: 0,
                Value: stock_model.aValue,
                Text: "A",
                Color: pointColor
              },
              {
                Date: stock_model.b,
                Time: 0,
                Value: stock_model.bValue,
                Text: "B",
                Color: pointColor
              },
              {
                Date: stock_model.c,
                Time: 0,
                Value: stock_model.cValue,
                Text: "C",
                Color: pointColor
              },
              {
                Date: stock_model.d,
                Time: 0,
                Value: stock_model.dValue,
                Text: "D",
                Color: pointColor
              },
              {
                Date: stock_model.b,
                Time: 0,
                Value: model_text_show_value,
                Text: stock_model.modelType,
                Color: pointColor
              },
              {
                //xb
                Date: stock_model.a,
                Time: 0,
                Value: (
                  (parseFloat(stock_model.xValue) +
                    parseFloat(stock_model.bValue)) /
                  2
                ).toFixed(2),
                Text: (
                  Math.abs(
                    parseFloat(stock_model.bValue) -
                      parseFloat(stock_model.aValue)
                  ) /
                  Math.abs(
                    parseFloat(stock_model.xValue) -
                      parseFloat(stock_model.aValue)
                  )
                ).toFixed(3),
                Color: pointColor
              },
              {
                //ac
                Date: stock_model.b,
                Time: 0,
                Value: (
                  (parseFloat(stock_model.aValue) +
                    parseFloat(stock_model.cValue)) /
                  2
                ).toFixed(2),
                Text: (
                  Math.abs(
                    parseFloat(stock_model.bValue) -
                      parseFloat(stock_model.cValue)
                  ) /
                  Math.abs(
                    parseFloat(stock_model.bValue) -
                      parseFloat(stock_model.aValue)
                  )
                ).toFixed(3),
                Color: pointColor
              },
              {
                //bd
                Date: stock_model.c,
                Time: 0,
                Value: (
                  (parseFloat(stock_model.bValue) +
                    parseFloat(stock_model.dValue)) /
                  2
                ).toFixed(2),
                Text: (
                  Math.abs(
                    parseFloat(stock_model.dValue) -
                      parseFloat(stock_model.cValue)
                  ) /
                  Math.abs(
                    parseFloat(stock_model.bValue) -
                      parseFloat(stock_model.cValue)
                  )
                ).toFixed(3),
                Color: "rgb(105,105,105)"
              }
            ]
          } //绘制X,A,B,C,D
        };

        var point = {
          Color: "rgb(105,105,105)",
          Point: [
            { Date: stock_model.x, Value: stock_model.xValue },
            { Date: stock_model.a, Value: stock_model.aValue },
            { Date: stock_model.b, Value: stock_model.bValue },
            { Date: stock_model.c, Value: stock_model.cValue },
            { Date: stock_model.d, Value: stock_model.dValue }
          ]
        };

        var xbd_point = {
          Color: "rgb(105,105,105)",
          Point: [
            { Date: stock_model.x, Value: stock_model.xValue },
            { Date: stock_model.b, Value: stock_model.bValue },
            { Date: stock_model.d, Value: stock_model.dValue }
          ]
        };

        var ac_point = {
          Color: "rgb(105,105,105)",
          Point: [
            { Date: stock_model.a, Value: stock_model.aValue },
            { Date: stock_model.c, Value: stock_model.cValue }
          ]
        };

        gartley_line.Draw.DrawData.push(point);
        xbd_line.Draw.DrawData.push(xbd_point);
        xbd_line.Draw.DrawData.push(ac_point);

        var apiData = {
          code: 0,
          stock: { name: hqchart.Name, symbol: hqchart.Symbol },
          outdata: {
            date: kData.GetDate(),
            outvar: [closeLine, gartley_line, text, xbd_line]
          }
        };

        data.PreventDefault = true;
        console.log("[NetworkFilter::NetworkFilter] apiData ", apiData);
        callback(apiData);
      }
    }
  }

  let data = {
    Type: "历史K线图",
    //窗口指标
    Windows: [
      {
        Index: "多线段指标",
        API: {
          Name: "多线段指标",
          Script: null,
          Args: null,
          Url: "http://8.142.1.214:18080/api/jsindex"
          //Url: "http://localhost:18080/api/jsindex"
        }
      },
      {
        Index: "MACD",
        Modify: false,
        Change: false
      }
      // {
      //   Index: "MA",
      //   Modify: false,
      //   Change: false
      // }
      // {
      //   Index: "VOL",
      //   Modify: false,
      //   Change: false
      // }
      // {
      //   Index: "RSI",
      //   Modify: false,
      //   Change: false,
      //   IsDrawTitleBG: true
      // }
    ],
    //标题设置
    KLineTitle: {
      IsShowName: true, //不显示股票名称
      IsShowSettingInfo: true //不显示周期/复权
    },
    IsShowCorssCursorInfo: true,
    //边框
    Border: {
      Left: 1,
      Right: 1, //右边间距
      Top: 25,
      Bottom: 25
    },
    KLine: {
      DragMode: 1, //拖拽模式 0=禁止拖拽 1=数据拖拽 2=区间选择 3=点击模式
      Right: 1, //复权 0 不复权 1 前复权 2 后复权
      Period: 0, //周期: 0 日线 1 周线 2 月线 3 年线
      PageSize: 70,
      IsShowTooltip: true
    },
    NetworkFilter: NetworkFilter
  };
  return data;
};
export default {
  data() {
    var data = {
      Symbol:
        stock_model.code + (stock_model.market == "上海A股" ? ".sh" : ".sz"),
      KLine: {
        JSChart: null,
        Option: DefaultData.GetKLineOption()
      }
    };
    return data;
  },
  created() {
    axios = this.$axios;
    bus.$on("current_stock_model", data => {
      stock_model = data;
      this.Symbol =
        stock_model.code + (stock_model.market == "上海A股" ? ".sh" : ".sz");

      console.log("======================" + this.Symbol);
      var reg = new RegExp("-", "g");
      stock_model.x = stock_model.x.replace(reg, "");
      stock_model.a = stock_model.a.replace(reg, "");
      stock_model.b = stock_model.b.replace(reg, "");
      stock_model.c = stock_model.c.replace(reg, "");
      stock_model.d = stock_model.d.replace(reg, "");

      this.KLine.JSChart.ChangeSymbol(this.Symbol);
    });
  },
  mounted() {
    this.OnSize();
    window.onresize = () => {
      this.OnSize();
    };
    this.CreateKLineChart();
  },
  methods: {
    OnSize() {
      var chartHeight = window.innerHeight - 180;
      var chartWidth = window.innerWidth - 350;

      var kline = this.$refs.kline;
      kline.style.width = chartWidth + "px";
      kline.style.height = chartHeight + "px";

      if (this.KLine.JSChart) this.KLine.JSChart.OnSize();
    },

    CreateKLineChart() {
      console.log("CreateKLineChart");
      //创建K线图
      if (this.KLine.JSChart) return;
      this.KLine.Option.Symbol = this.Symbol;

      let chart = HQChart.Chart.JSChart.Init(this.$refs.kline);
      chart.SetOption(this.KLine.Option);
      this.KLine.JSChart = chart;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/DailyKline.vue